import React from "react";

const iconWrap = (children, accent, className, compact, bare) => {
  if (bare) {
    return (
      <span className={`inline-flex shrink-0 items-center justify-center ${className}`} style={{ color: accent }} aria-hidden>
        {children}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-md bg-gray-100 dark:bg-navy-800 ${
        compact ? "h-5 w-5" : "h-8 w-8 rounded-lg"
      } ${className}`}
      style={{ color: accent }}
      aria-hidden
    >
      {children}
    </span>
  );
};

/** Visible channel glyph for Summary strip and monitoring boxes. */
export default function GreatSummaryChannelIcon({
  channelKey,
  accent = "#64748B",
  className = "",
  compact = false,
  bare = false,
}) {
  const svgSize = compact || bare ? 14 : 18;

  switch (channelKey) {
    case "inbound":
      return iconWrap(
        <svg width={svgSize} height={svgSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
          <path strokeLinecap="round" d="M16 3l5 5M21 3v5h-5" />
        </svg>,
        accent,
        className,
        compact,
        bare
      );
    case "outbound":
      return iconWrap(
        <svg width={svgSize} height={svgSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
          <path strokeLinecap="round" d="M16 8l5-5M21 8V3h-5" />
        </svg>,
        accent,
        className,
        compact,
        bare
      );
    case "email":
      return iconWrap(
        <svg width={svgSize} height={svgSize} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>,
        accent,
        className,
        compact,
        bare
      );
    case "live-chat":
      return iconWrap(
        <svg width={svgSize} height={svgSize} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h2v3c0 .6.7.9 1.1.5L12 18h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9H7v-2h6v2zm4-3H7V6h10v2z" />
        </svg>,
        accent,
        className,
        compact,
        bare
      );
    case "sms":
      return iconWrap(
        <svg width={svgSize} height={svgSize} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z" />
        </svg>,
        accent,
        className,
        compact,
        bare
      );
    default:
      return null;
  }
}
